import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { supabase } from "@/lib/supabase";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    // null = checking, false = anonymous, object = signed-in user
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const refresh = useCallback(async () => {
        const { data } = await supabase.auth.getSession();
        if (data?.session?.user) {
            const u = data.session.user;
            setUser({ id: u.id, email: u.email, role: u.role || "authenticated" });
        } else {
            setUser(false);
        }
        setLoading(false);
    }, []);

    useEffect(() => {
        refresh();
        const { data: sub } = supabase.auth.onAuthStateChange((_event, session) => {
            if (session?.user) {
                setUser({ id: session.user.id, email: session.user.email, role: session.user.role || "authenticated" });
            } else {
                setUser(false);
            }
        });
        return () => sub.subscription.unsubscribe();
    }, [refresh]);

    const login = async (email, password) => {
        const { data, error } = await supabase.auth.signInWithPassword({ email, password });
        if (error) throw new Error(error.message || "Email ou mot de passe incorrect");
        const u = data.user;
        const userData = { id: u.id, email: u.email, role: u.role || "authenticated" };
        setUser(userData);
        return userData;
    };

    const logout = async () => {
        await supabase.auth.signOut();
        setUser(false);
    };

    return (
        <AuthContext.Provider value={{ user, loading, login, logout, refresh }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    const ctx = useContext(AuthContext);
    if (!ctx) throw new Error("useAuth must be used within AuthProvider");
    return ctx;
}
